'use strict';

module.exports = tbmv;

function tbmv () {
  console.error('TBMV (triangular banded matrix vector multiply) not yet implemented');
}
